export const AMPLITUDE_DEVICE_ID_COOKIE_NAME = 'cfAmpAnonymousId'
export const AMPLITUDE_SESSION_ID_COOKIE_NAME = 'cfAmpSessionId'
